export default function(timeString) {
  const newDate = new Date(timeString)
  return newDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
}
